module.exports = __webpack_public_path__ + "img/linkedin-color.5ff79e36.svg";